import { createProductItem, googleAnalyticWithHashEmailPhone, googleAnalyticsAddPaymentInfo, googleAnalyticsNormalAction, googleAnalyticsQuotationBtn, googleAnalyticsSuccessPage, googleAnalyticsWithCarAndApplicantDetails, googleAnalyticsWithCarDetails, googleAnalyticsWithQuotationDetails } from "@/helpers/GoogleAnalytic";
import { useAppSelector } from "@/hook";
import { useRouteSection } from "./useRouteSection";
import { startCase } from "lodash";
import CryptoJS from "crypto-js";
import { IdType, PlanType } from "@/enums";
import { getEntityTypeKey, getProductCode, getProductName } from "@/utility/common";
import { getPlanTypeName } from "@/helpers/PlanHelper";
import { EGTB_FULL } from "@/constants";
import Cookies from 'js-cookie';

export function useGoogleAnalytic() {
    const { uiState, planSummary, info, personalDetail, quotationDetail } = useAppSelector((state) => ({
        uiState: state.uiState,
        planSummary: state.planSummary,
        info: state.infoState,
        personalDetail: state.infoState.personalDetail,
        quotationDetail: state.planSummary.quotationDetail
    }));

    const productType = useRouteSection();
    const productCode = getProductCode(productType);
    const productName = getProductName(productType);
    const entity = getEntityTypeKey(productType).toUpperCase();

    const storedData = Cookies.get('myCookie');
    const myCookieData = storedData !== undefined ? JSON.parse(storedData) : null;

    const setCookieWithExpiration = (
        cookieName: string,
        data: any,
        minutes: number,
    ) => {
        return;
        const serializedData = JSON.stringify(data);

        const expirationTime = new Date(
            new Date().getTime() + minutes * 60 * 1000,
        );

        Cookies.set(cookieName, serializedData, {
            expires: expirationTime,
            path: '/',
        });
    };

    const goToHome = async () => {
        return;
        const hashPhoneNumber = info.personalDetail.mobileNo !== '' ? CryptoJS.SHA256(info.personalDetail.mobileNo).toString() : undefined;
        const hashEmail = info.personalDetail.email !== '' ? CryptoJS.SHA256(info.personalDetail.email).toString() : undefined;
        googleAnalyticWithHashEmailPhone(
            'go_to_home',
            `OTO360 - ${startCase(productType)}`,
            'Go To Home',
            'Home',
            undefined,
            undefined,
            hashPhoneNumber,
            hashEmail
        );
    }

    const selectLanguage = (newLanguage: string) => {
        return;
        googleAnalyticsNormalAction(
            'select_language',
            `OTO360 - ${startCase(productType)}`,
            'Select Language',
            newLanguage
        );
    }

    const beginQuotation = async () => {
        return;
        const hashPhoneNumber = info.personalDetail.mobileNo?.length > 8 ? CryptoJS.SHA256(info.personalDetail.mobileNo).toString() : undefined;
        const hashEmail = info.personalDetail.email !== '' ? CryptoJS.SHA256(info.personalDetail.email).toString() : undefined;
        const idType = info.personalDetail.idType != 0 ? IdType[info.personalDetail.idType] : '';
        const vehiecleNumber = info.vehicleDetail.vehicleNumber;

        googleAnalyticsQuotationBtn(
            'pa_begin_quotation',
            `OTO360 - ${startCase(productType)}`,
            'Begin Quotation',
            'Quotation',
            undefined,
            undefined,
            hashPhoneNumber,
            hashEmail,
            idType,
            vehiecleNumber,
        );
    }

    const goToProductList = () => {
        return;
        googleAnalyticsNormalAction(
            'go_to_product_list',
            `OTO360 - ${startCase(productType)} - Policy Reminder`,
            'Go To Product List',
            'Product List'
        );
    }

    const goToProductListAfterSubmit = () => {
        return;
        googleAnalyticsNormalAction(
            'go_to_product_list',
            `OTO360 - ${startCase(productType)} - Policy Reminder Submitted`,
            'Go To Product List',
            'Product List'
        );
    }

    const goToProductListUnableToProceed = () => {
        return;
        googleAnalyticsNormalAction(
            'go_to_product_list',
            `OTO360 - ${startCase(productType)} - Unable To Proceed Application`,
            'Go To Product List',
            'Product List'
        );
    }

    const setReminder = () => {
        return;
        googleAnalyticsNormalAction(
            'set_reminder',
            `OTO360 - ${startCase(productType)} - Policy Reminder`,
            'Set Reminder',
            'Reminder'
        );
    }

    const submitCarDetails = () => {
        return;
        googleAnalyticsWithCarDetails(
            'pa_submit_car_details',
            `OTO360 - ${productType} - Submit Car Details`,
            'Submit Car Details',
            'Car Details',
            `${planSummary.processVehicle?.registrationNo}`,
            `${planSummary.processVehicle?.make}`,
            `${planSummary.processVehicle?.model}`,
            `${planSummary.processVehicle?.chassisNo}`
        )
    }

    const viewSummary = (show: boolean) => {
        return;
        googleAnalyticsNormalAction(
            show ? 'expand_section' : 'hide_section',
            `OTO360 - ${productType} - Choose Plan`,
            show ? 'Expand Section' : 'Hide Section',
            'Premium Summary'
        );
    }

    const addToCart = () => {
        return;
        let planDetails = [];
        const itemVariant = quotationDetail?.planType !== undefined ? getPlanTypeName(quotationDetail?.planType) ?? '' : '';
        const planPrice = quotationDetail?.planPremium.totalPremium ?? 0;
        const carModel = planSummary.processVehicle?.model ?? info.vehicleDetail.vehicleModel;
        const sumInsured = quotationDetail?.planPremium.sumAssured;

        const plan = createProductItem(
            productCode,
            productName,
            entity,
            'PA',
            'Plan',
            itemVariant,
            'MYR',
            planPrice,
            1,
            'N/A',
            'Annual',
            carModel,
            undefined,
            undefined,
            'One Time',
            `${sumInsured}`,
            '1'
        )

        planDetails.push(plan);
        googleAnalyticsWithQuotationDetails(
            'add_to_cart',
            `OTO360 - ${startCase(productType)} - Choose Plan`,
            'Add To Cart',
            productName,
            'MYR',
            planPrice,
            planDetails
        );
    }

    const beginCheckout = async () => {
        return;
        const vehiecleNumber = info.vehicleDetail.vehicleNumber;
        const carBrand = planSummary.processVehicle?.make ?? info.vehicleDetail.vehicleBrand;
        const carModel = planSummary.processVehicle?.model ?? info.vehicleDetail.vehicleModel;
        const carChassisNumber = info.vehicleDetail.chassisNumber;
        const takafulOperator = EGTB_FULL;
        const nationality = uiState.nationalityList.find((n) => n.code === info.personalDetail.nationality)?.name ?? '';
        
        const hashPhoneNumber = info.personalDetail.mobileNo !== '' && info.personalDetail.mobileNo.length > 8 ? CryptoJS.SHA256(info.personalDetail.mobileNo).toString() : '';
        const hashEmail = info.personalDetail.email !== '' ? CryptoJS.SHA256(info.personalDetail.email).toString() : '';
        const postcode = info.homeAddressDetail.postcode;
        const state = info.homeAddressDetail.state;
        const country = info.homeAddressDetail.country;
        const bankName = info.bankAccountDetail.bankName || uiState.bankList.find((bank) => bank.id === info.bankAccountDetail.bankId)?.bankName;
        const totalPrice = quotationDetail?.planPremium.totalPremium ?? 0;

        let planDetails = [];
        const itemVariant = quotationDetail?.planType !== undefined ? getPlanTypeName(quotationDetail?.planType) ?? '' : '';
        const planPrice = quotationDetail?.planPremium.netPremium ?? 0;
        const sumInsured = quotationDetail?.planPremium.sumAssured;

        const plan = createProductItem(
            productCode,
            productName,
            entity,
            'PA',
            'Plan',
            itemVariant,
            'MYR',
            planPrice,
            1,
            'N/A',
            'Annual',
            carModel,
            undefined,
            undefined,
            'One Time',
            `${sumInsured}`,
            '1'
        );

        planDetails.push(plan);

        googleAnalyticsWithCarAndApplicantDetails(
            'begin_checkout',
            `OTO360 - ${productType} - Fill In The Details`,
            'Begin Checkout',
            productName,
            vehiecleNumber,
            carBrand,
            carModel,
            carChassisNumber,
            takafulOperator,
            nationality,
            hashPhoneNumber,
            hashEmail,
            postcode,
            state,
            country,
            bankName,
            'MYR',
            totalPrice,
            planDetails
        );
    }

    const addPaymentInfo = () => {
        return;
        let planDetails = [];
        const itemVariant = quotationDetail?.planType !== undefined ? getPlanTypeName(quotationDetail?.planType) ?? '' : '';
        const planPrice = quotationDetail?.planPremium.netPremium ?? 0;
        const totalPrice = quotationDetail?.planPremium.totalPremium ?? 0;
        const carModel = planSummary.processVehicle?.model ?? info.vehicleDetail.vehicleModel;
        const sumInsured = quotationDetail?.planPremium.sumAssured;
        const paymentType = planSummary.payMode;

        const plan = createProductItem(
            productCode,
            productName,
            entity,
            'PA',
            'Plan',
            itemVariant,
            'MYR',
            planPrice,
            1,
            'N/A',
            'Annual',
            carModel,
            undefined,
            undefined,
            'One Time',
            `${sumInsured}`,
            '1'
        );

        planDetails.push(plan);

        googleAnalyticsAddPaymentInfo(
            'add_payment_info',
            `OTO360 - ${productType} - Declaration & Payment`,
            'Add Payment Info',
            productName,
            'MYR',
            totalPrice,
            'N/A',
            paymentType,
            planDetails
        );

        planDetails = JSON.parse(JSON.stringify(planDetails, (key, value) => (value === undefined ? null : value)));

        const dataToStore = {
            planDetails,
            totalPrice
        }

        setCookieWithExpiration('myCookie', dataToStore, 15);
    }

    const paymentSuccess = (transactionNo: string, policyNo: any) => {
        return;

        if (myCookieData !== null) {

            const planDetails = myCookieData.planDetails;
            const totalPrice = myCookieData.totalPrice;
            const updatePolicyNoArray = planDetails.map((item: any) => {
                return {
                    ...Object.fromEntries(
                        Object.entries(item).map(([key, value]) => [key, value === null ? undefined : value])
                    ),
                    epolicy_number: policyNo[0],
                };
              });

            googleAnalyticsSuccessPage(
                'purchase',
                `OTO360 - ${productType} - Payment Success`,
                'Purchase',
                productName,
                undefined, // profit
                'MYR',
                totalPrice,
                'N/A',
                transactionNo,
                updatePolicyNoArray
            )
        }
    }

    return {
        goToHome,
        selectLanguage,
        beginQuotation,
        goToProductList,
        goToProductListAfterSubmit,
        goToProductListUnableToProceed,
        setReminder,
        submitCarDetails,
        viewSummary,
        addToCart,
        beginCheckout,
        addPaymentInfo,
        paymentSuccess
    }
}